import { Routes, Route } from '@angular/router';
import { ShellComponent } from './shell.component';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { BaseService } from '../shared/base.service';
import { ConfigService } from '../shared/config.service';
import { AuthGuard } from '../core/authentication/auth.guard';

@Injectable({
  providedIn: 'root'
})
export class Shell extends BaseService {

  constructor(private http: HttpClient, private configService: ConfigService) {
    super();
  }

  static childRoutes(routes: Routes): Route {
    return {
      path: '',
      component: ShellComponent,
      canActivate: [AuthGuard],
      children: routes,
      data: { reuse: true }
    };
  }

  getmenu(token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: token
      })
    };

    return this.http.get(this.configService.resourceApiURI + '/Menu', httpOptions)
      .pipe(catchError(this.handleError));
  }
}
